import React, {useState} from 'react';
import '../styles/navbar.css';


// icons
import navbarIcon from '../Assets/Images/navbar-icon.png';
import Hamburger from "./hamburger";

const Navbar = () => {
    const [hamburgerOpen, setHamburgerOpen] = useState(false);

    const toggleHamburger = () =>{
        setHamburgerOpen(!hamburgerOpen)
    }

    return (
        <nav className="navbar">
            <div className="navbar-left">
                <a href="/" className="logo">
                    <img
                        src={navbarIcon}
                        alt=""
                        style={{width: '84px', height: '84px'}}
                    />
                </a>
            </div>
            <div className="center">
                <p style={
                    {color: 'white', fontSize: '20px'}
                }>
                    A 5K RHYTHM GAME THAT NEVER MISSES.
                </p>

            </div>
            <div className="navbar-right">
                <div className="hamburger" onClick={toggleHamburger}>
                    <Hamburger isOpen={hamburgerOpen}/>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
